import environment from '@environments/environment';

export default {
  oidc: {
    clientId: environment.Okta.clientId,
    issuer: environment.Okta.issuer,
    redirectUri: environment.Okta.redirectUri,
    scopes: ['openid', 'profile', 'email', 'offline_access', 'Clinsphere_Scope'],
    // pkce: true,
    testing: {
      disableHttpsCheck: `${environment.Okta.disableHttpsCheck}`,
    },
  },
};
